import { render } from "./AreasManagement.html?vue&type=template&id=3d9486fc&scoped=true"
import script from "./AreasManagement.js?vue&type=script&lang=js"
export * from "./AreasManagement.js?vue&type=script&lang=js"

import "./AreasManagement.css?vue&type=style&index=0&id=3d9486fc&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9486fc"]])

export default __exports__